// frontend/src/motion/useMotion.js
//
// React view onto the single motion switch (see motionSignal.js).
//
// useSyncExternalStore rather than useState + useEffect: the state has to be
// correct on the FIRST render, not one commit later. A hero that renders its
// entrance animation and then removes it a frame afterwards is exactly the flash
// the accessibility toggle exists to prevent. `getMotionState()` returns a
// stable object between changes, which is what the store contract requires.
//
// The server snapshot is the same reader - it degrades to "motion allowed" with
// no window, and the reveal hooks force their final state under
// `window.__PRERENDER__` anyway.

import { useSyncExternalStore } from "react";
import { getMotionState, subscribeMotion } from "./motionSignal";

/**
 * @returns {import("./motionSignal").MotionState} the live motion state.
 */
export default function useMotion() {
  return useSyncExternalStore(subscribeMotion, getMotionState, getMotionState);
}

export { useMotion };
